import React from "react";
import { NavLink } from "react-router-dom";
import instalogo from "../assets/img/insta-footer.png";

const Footer = () => {
  return (
    <div className="footer-container">
      <div>
        <div className="footer-droits">© All rights reserved</div>
        <div className="footer-insta">
          <a
            href="http://www.instagram.com/elize.sokolova"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instalogo} alt="Instagram" width="32" height="32" />
          </a>
        </div>
        {/*<div className="footer-mentions">
          <NavLink to="/Legal">{"Mentions légales"}</NavLink>
        </div>*/}
      </div>
      {/*<div>
        <div className="footer-mail">
          <a href="mailto:elizesokolova@gmail.com">E-MAIL</a>
        </div>
        <div className="footer-links">
          <a href="http://www.instagram.com/elize.sokolova">
            <img
              src={`${process.env.REACT_APP_DATA_URL}/img/logo-insta.png`}
              alt="Instagram"
              width="30"
              height="30"
            />
          </a>
          <a href="https://www.linkedin.com/in/elize-sokolova-69a758172/">
            <img
              src={`${process.env.REACT_APP_DATA_URL}/img/logo-linkedin.png`}
              alt="LinkedIn"
              width="30"
              height="30"
            />
          </a>
        </div>
      </div>*/}
    </div>
  );
};

export default Footer;
